import React, { useState } from "react";
import {
  LayoutDashboard,
  MapPin,
  Clock,
  DollarSign,
  Route,
  Train,
  Bell,
  Settings,
} from "lucide-react";
import MetroLogo from "../../Assets/MetroLogo.png"
import { NavLink, useLocation } from "react-router-dom";
const Sidebar = ({ collapsed }) => {
  const location = useLocation();
  const menuItems = [
    // { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, href: "/dashboard" },
    { id: "Lines", label: "Lines", icon: Route, href: "/lines" },
    { id: "stations", label: "Stations", icon: MapPin, href: "/stations" },
    { id: "silder", label: "Silder", icon: MapPin, href: "/imageDashboardView" },
    // { id: "routes", label: "Routes", icon: Route, href: "/routes" },
    // { id: "timetables", label: "Timetables", icon: Clock, href: "/timetables" },
    { id: "fares", label: "Fare Management", icon: DollarSign, href: "/fares" },
    // { id: "settings", label: "Settings", icon: Settings, href: "/settings" },
  ];

  return (
    <aside
      className={`h-screen ${
        collapsed ? "w-[78px]" : "w-[230px]"
      } border-r border-gray-200 bg-white/80 backdrop-blur-sm transition-all duration-300 ease-in-out`}
    >
      <div className="flex h-full flex-col">
        {/* Header */}
        <div
          className={`flex h-16 items-center  border-b border-gray-200 cursor-pointer ${
            collapsed ? "px-0 justify-center" : "px-3 justify-start"
          }`}
          onClick={() => window.location.reload()}
        >
          <div className="flex items-center gap-[5px] cursor-pointer">
            <img
              src={MetroLogo}
              alt="logo"
              className="h-[58px] w-[58px] "
            ></img>
            {!collapsed && (
              <div>
                <h1 className="text-lg font-bold text-[var(--black)] text-nowrap mb-0">
                  Indore Metro
                </h1>
                <p className="text-xs text-[var(--grey-text)] mb-0">
                  Admin Dashboard
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 pt-3 px-3">
          <ul className="flex flex-col gap-2 p-0">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.href;
              return (
                <li key={item.id}>
                  <NavLink
                    to={item.href}
                    className={`flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-all duration-200 ${
                      isActive
                        ? "bg-[var(--primary-color)] text-[var(--white)] shadow-md"
                        : "text-[var(--grey-text)] hover:bg-gray-100 hover:text-[var(--black)]"
                    }`}
                  >
                    <Icon className="h-5 w-5 flex-shrink-0" />
                    <span className="truncate">{item.label}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
